import { State } from '@progress/kendo-data-query';

/** Sort fragment merged into keyset POST bodies when the API expects it. */
export interface KeysetSortFields
{
  sortProperty?: string;
  sortDirection?: string;
}

/** Per-grid mapping from grid {@link State} (and optional context) to API sort fields. */
export interface KeysetSortStrategy<TContext = any>
{
  resolveSort(state: State, context: TContext): KeysetSortFields;
}

/** Passed to {@link createKeysetSortStrategy} resolveSort (e.g. {@code recentOnly} from the list). */
export interface KeysetSortContext
{
  recentOnly: boolean;
}

export interface CreateKeysetSortStrategyOptions
{
  /** Used when the grid has no column sort and sort is not omitted for the current context. */
  defaultSort: Required<Pick<KeysetSortFields, 'sortProperty' | 'sortDirection'>>;
}

/**
 * Keyset sort: honor the grid's active column sort; otherwise use {@link CreateKeysetSortStrategyOptions.defaultSort},
 * except when {@link KeysetSortContext.recentOnly} is true and there is no column sort (omit sort — server default).
 */
export function createKeysetSortStrategy(
  options: CreateKeysetSortStrategyOptions
): KeysetSortStrategy<KeysetSortContext>
{
  return {
    resolveSort(state: State, context: KeysetSortContext): KeysetSortFields
    {
      const activeSort = state.sort?.[0];
      if (activeSort?.field)
      {
        return {
          sortProperty: activeSort.field,
          sortDirection: activeSort.dir !== undefined
            ? String(activeSort.dir).toUpperCase()
            : 'ASC'
        };
      }
      if (context.recentOnly)
      {
        return {};
      }
      return options.defaultSort;
    }
  };
}
